/**
 * INT-1500 U7: the id of the radio input that opens the lead's attributes in
 * the chat's side panel. "Editar lead" finds the panel by it.
 */
export const CHAT_INFO_ATTRIBUTES_TOGGLE_ID = 'ChatInfo__AttributesToggle';

/**
 * INT-1500 U7: "Editar lead" on a template refused for empty lead variables.
 * Opens the attributes panel beside the chat (its accordion is one radio
 * group, so opening it closes Notas or any other), brings it into view and
 * puts the cursor in its first field. Does nothing without the panel.
 */
export function revealLeadAttributes(): void {
  const toggle = document.getElementById(CHAT_INFO_ATTRIBUTES_TOGGLE_ID);
  if (!(toggle instanceof HTMLInputElement)) return;

  toggle.checked = true;
  const panel = toggle.parentElement;
  panel?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  panel
    ?.querySelector<HTMLElement>(
      'input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]), textarea',
    )
    ?.focus({ preventScroll: true });
}
